import { DeltaText } from '@spotify/plugin-confidence-activity-react';
import { createWorkflowUpdatesChangeExtension } from '@spotify/plugin-confidence-workflows-react';

interface FlagsModuleData {
  stickyAssignments?: boolean;
  audience?: unknown;
  [key: string]: unknown;
}

export const FLAGS_CHANGE_EXTENSION = createWorkflowUpdatesChangeExtension({
  id: 'flags-module-data-change',
  predicate: ({ change }) => change.fieldPath === '/module_data/flags',
  title: change => {
    const oldValue = change.oldValue as FlagsModuleData | null;
    const newValue = change.newValue as FlagsModuleData | null;

    if (
      oldValue?.stickyAssignments !== undefined &&
      newValue?.stickyAssignments !== undefined &&
      oldValue.stickyAssignments !== newValue.stickyAssignments
    ) {
      return 'Updated sticky assignments';
    }

    if (
      (oldValue?.audience !== undefined || newValue?.audience !== undefined) &&
      oldValue?.audience !== newValue?.audience
    ) {
      return 'Updated audience';
    }

    return 'Updated flag configuration';
  },
  render: () => (
    <DeltaText oldText="" newText="Configuration updated" disableDiff />
  ),
});
